class Announcement {
  title = "";
  text = "";
  image = null;
  touserid = null;
  toagencyid = null;
  priority = null;
  date = null;

  createdby = null;
  updatedby = null;

  static getFormData(object, isPutMethod = false) {
    console.log("creating form data ....");
    const formData = new FormData();
    formData.append("title", object.title);
    formData.append("text", object.text);
    formData.append("amount", object.amount);
    if (object.link) {
      formData.append("link", object.link);
    }
    if (object.date) {
      formData.append("date", object.date);
    }
    formData.append("priority", object.priority);
    if (formData.toagencyid) {
      formData.append("touserid", object.touserid);
    }
    if (formData.toagencyid) {
      formData.append("toagencyid", object.toagencyid);
    }
    if (object.image) {
      formData.append("image", object.image);
    }
    if (isPutMethod) {
      formData.append("_method", "PUT");
    }
    return formData;
  }
}
export default Announcement;
